// extracted by mini-css-extract-plugin
module.exports = {"container":"e_xA","up":"e_yA","down":"e_zA","percent":"e_AA","percentVal":"e_BA","title":"e_CA","tags":"e_DA","textBadge":"e_EA"};